<template>
  <div>
    <div style="margin-bottom: 10px;">
      <CustCard
        :title="$l('form_header_baseInfo') || '客户信息'"
        :desc="
          $l('form_desc_baseInfo') ||
            '客户公司名称、税号（国外公司VAT No，国内公司统一征信码）、背景情况等基础信息'
        "
      >
        <CustBase :custCode="custCode" @loaded="(e) => $emit('loaded', e)" />
      </CustCard>
    </div>
    <div class="d-flex">
      <div style="margin-right: 10px;width: calc(40% - 10px);min-width: 360px;">
        <CustCard
          :title="$l('form_header_dep') || '客户分支机构'"
          :desc="$l('form_desc_dep') || '客户分支机构及部门信息'"
        >
          <CustDep :custCode="custCode" />
        </CustCard>
      </div>
      <div style="width: 60%;min-width: 560px;">
        <CustCard
          :title="$l('form_header_bankInfo') || '客户银行账号'"
          :desc="$l('form_desc_bankInfo') || '客户银行账号信息'"
        >
          <CustBank :custCode="custCode" />
        </CustCard>
      </div>
    </div>
  </div>
</template>

<script>
import CustBase from '../cust-base'
import CustDep from '../cust-dep'
import CustBank from '../cust-bank'
import CustCard from '../cust-card'
export default {
  components: { CustBase, CustDep, CustBank, CustCard },
  props: { custCode: { type: String, default: '' } },
}
</script>
